import {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {AxiosError} from 'axios'
import * as bootstrap from 'bootstrap'
import {useLang} from '../../../../../_metronic/i18n/Metronici18n'
import {
  listCategory,
  listCategoryTree,
  saveExperimentCategory,
} from '../../../../modules/auth/core/_requests'
import {KTSVG} from '../../../../../_metronic/helpers'
import TreeBuilder2 from '../../Components/TreeBuilder2'

const profileDetailsSchema = Yup.object().shape({
  category: Yup.number().required('Category is required'),
})

function CreateExperimentCategoryModal({
  itemId,
  setAction,
  SuccessfulNotify,
  UnsuccessfulNotify,
}: any) {
  const [categoryList, setCategoryList] = useState([])
  const [treeData, setTreeData] = useState([])
  const lang = useLang()

  useEffect(() => {
    getList()
  }, [])

  const getList = async () => {
    try {
      const {data} = await listCategory(0, 0, '', '', '', '')
      setCategoryList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const initialValues = {
    category: 0,
    hiyerarsiMap: '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values, {resetForm}) => {
      try {
        const {data} = await saveExperimentCategory(itemId, values.category)
        setAction(true)
        resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#createTabContentECategory_modal')
        modal.hide()
        //
        SuccessfulNotify('Registration Successfully Added.')
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        UnsuccessfulNotify(String(error))
        console.error(error)
      }
    },
  })

  useEffect(() => {
    getTreeData()
  }, [categoryList])

  async function getTreeData() {
    try {
      const {data} = await listCategoryTree(true, 0, 0, '', lang, '', '')
      setTreeData(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const SelectedTags = (tags: any) => {
    formik.setFieldValue('hiyerarsiMap', tags)
  }

  const SelectedCategory = (birimId: any) => {
    formik.setFieldValue('category', birimId)
  }

  return (
    <div className='modal fade' tabIndex={-1} id={`createTabContentECategory_modal`}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Create Category</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}

                <div className='mb-10'>
                  <label className='form-label'>Category</label>
                  <div className='border border-dashe rounded border-1'>
                    <TreeBuilder2
                      SetUstBirimId={SelectedCategory}
                      setHiyerarsiMap={SelectedTags}
                      loop={1}
                      birims={treeData}
                      categorytList={categoryList}
                    />
                  </div>
                  <span className='badge badge-light-primary mt-2'>
                    {' '}
                    Selected Category :
                    <span className='badge bg-light text-dark'>
                      {' '}
                      {formik.values.hiyerarsiMap !== '' ? formik.values.hiyerarsiMap : 'empty'}
                    </span>
                  </span>

                  {formik.touched.category && formik.errors.category && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.category}</div>
                    </div>
                  )}
                </div>

                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>

                <button type='submit' className='btn btn-primary'>
                  Create Category
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateExperimentCategoryModal
